import { X } from 'lucide-react';

import ChatbotIcon from '#/assets/svgs/ChatbotIcon.svg';
import Whatsapp from '#/assets/svgs/Whatsapp.svg';

function ChatbotHeader({ botName, onlineStatus, chatBotImage, whatsappAdded, whatsappNumber, isResponsive, onClose }) {
  return (
    <div className="header">
      <div className="avatar-detail">
        <span className="image">{chatBotImage ? <img src={chatBotImage} alt="Chatbot" /> : <ChatbotIcon />}</span>
        <div className="detail">
          <h5>{botName}</h5>
          <p>{onlineStatus}</p>
        </div>
      </div>
      <div className="whatsapp-icon">
        {whatsappAdded && (
          <a href={`https://wa.me/${whatsappNumber}`} target="_blank">
            <Whatsapp />
          </a>
        )}
        {isResponsive && (
          <span onClick={onClose} className="cross-icon">
            <X />
          </span>
        )}
      </div>
    </div>
  );
}

export default ChatbotHeader;
